export default "__VITE_ASSET__52b4a7ad__"